<template>
  <el-dialog title="采购任务面板" :visible="visible" width="92%" append-to-body custom-class="task-panel-dialog"
      @update:visible="$emit('update:visible', $event)">
    <div class="task-panel-meta">
      <span>当前店铺：{{ shop || '-' }}</span>
      <span>当前父体：{{ parent || '-' }}</span>
      <span>仅本人任务 · 未选父体时展示本人全部任务 · 状态不会自动刷新，请手动刷新查看</span>
      <el-button class="task-panel-refresh" size="mini" icon="el-icon-refresh" :loading="busy"
          @click="refresh">刷新</el-button>
    </div>
    <el-alert v-if="error" :title="error" type="error" :closable="false" class="task-panel-error" />
    <el-table :data="items" border size="mini" max-height="360" class="task-panel-table"
        empty-text="当前店铺 / 父体下没有本人的采购任务">
      <el-table-column prop="draft_id" label="草稿 / 批次来源" min-width="250" show-overflow-tooltip />
      <el-table-column label="状态" width="120">
        <template slot-scope="s">
          <el-tag size="mini" effect="plain">{{ label(s.row.batch_status || s.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="item_count" label="MSKU 数" width="90" align="center" />
      <el-table-column prop="total_quantity" label="采购总量" width="100" align="center" />
      <el-table-column prop="created_at" label="创建时间" width="170" />
      <el-table-column label="操作" width="230" align="center" fixed="right">
        <template slot-scope="s">
          <div class="task-panel-actions">
            <el-button v-if="s.row.status === 'draft'" size="mini" @click="$emit('resume', s.row.draft_id)">继续草稿</el-button>
            <el-button v-if="s.row.status === 'draft'" size="mini" type="danger" plain @click="cancel(s.row)">取消草稿</el-button>
            <el-button size="mini" type="primary" plain @click="inspect(s.row.draft_id)">详情</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="task-panel-pagination">
      <el-pagination :current-page.sync="page" :page-size="20" :total="total" layout="prev, pager, next"
          @current-change="refresh" />
    </div>
    <div v-if="detail" class="task-panel-detail">
      <div class="task-panel-detail-header">
        <div>
          <h3>{{ detail.draft.draft_id }}</h3>
          <div class="task-panel-detail-meta">
            草稿状态：{{ label(detail.draft.status) }}
            <template v-if="detail.batch"> · 批次状态：{{ label(detail.batch.status) }}</template>
            · 已选 {{ selected.length }} 项（仅批次结束后可补采）
          </div>
        </div>
        <el-button size="small" type="primary" :disabled="!selected.length || !ended" @click="supplement">
          对选中待补采项补采
        </el-button>
      </div>
      <el-table :data="detail.details" row-key="id" border size="mini" max-height="320" @selection-change="selected = $event">
        <el-table-column type="selection" width="40" :selectable="selectable" reserve-selection />
        <el-table-column prop="parent" label="父体" /><el-table-column prop="pm" label="品名" />
        <el-table-column prop="msku" label="MSKU" min-width="180" />
        <el-table-column prop="publish_status" label="刊登状态" />
        <el-table-column prop="asin" label="ASIN" /><el-table-column prop="fnsku" label="FNSKU" />
        <el-table-column prop="sync_status" label="同步 / 配对" />
        <el-table-column prop="local_sku" label="local_sku" />
        <el-table-column prop="sku" label="目标 SKU" />
        <el-table-column label="采购状态"><template slot-scope="s">{{ label(s.row.status) }}</template></el-table-column>
        <el-table-column prop="plan_id" label="ERP 计划号" />
        <el-table-column label="异常" min-width="180"><template slot-scope="s">{{ s.row.procurement_error || s.row.error || s.row.publish_error }}</template></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>
<script>
const root = '/vue/parent_calculate/'
export default {
  props: { visible: Boolean, shop: { type: String, default: '' }, parent: { type: String, default: '' } },
  data() { return { items: [], total: 0, page: 1, detail: null, selected: [], error: '', generation: 0, busy: false } },
  computed: { ended() { return this.detail && this.detail.batch && ['succeeded', 'failed', 'partial_failed'].includes(this.detail.batch.status) } },
  watch: {
    // 任务推进由 auto_msku_monitor 负责，面板只在打开时拉一次，其余靠用户手动刷新。
    visible(value) { this.stop(); if (value) this.refresh() },
    parent() { this.resetScope() },
    shop() { this.resetScope() }
  },
  beforeDestroy() { this.stop() },
  methods: {
    resetScope() { this.generation++; this.page = 1; this.detail = null; this.selected = []; this.items = []; if (this.visible) this.refresh() },
    label(value) { return ({ draft: '待确认草稿', confirming: '确认中', cancelled: '已取消', reserved: '准备中', running: '准备中', purchasing: '整批采购中', succeeded: '采购成功', failed: '失败', partial_failed: '部分成功', procurement_ready: '采购就绪，等待整批', supplement_pending: '待补采', authorized: '等待采购', batch_pending: '待汇总采购', procurement_pending: '等待采购', submitting: '采购中', sync_timeout: '超时未同步', preparation_failed: '准备失败', result_unknown: '结果待核查' })[value] || value },
    stop() { this.generation++ },
    selectable(row) { return this.ended && row.status === 'supplement_pending' && !row.plan_id },
    async get(path, params) { const res = await this.$axios.get(root + path, { params: { shop: this.shop, parent: this.parent, ...params } }); if (res.msg !== 'success') throw new Error(res.message || '查询失败'); return res.data },
    async refresh() {
      if (!this.visible || this.busy || !this.shop) return
      this.busy = true
      const generation = this.generation
      try {
        const data = await this.get('procurement-tasks', { page: this.page })
        if (generation !== this.generation) return
        this.items = data.items; this.total = data.total; this.error = ''
        if (this.detail) await this.inspect(this.detail.draft.draft_id)
      } catch (e) { if (generation === this.generation) this.error = e.message } finally { this.busy = false }
    },
    async inspect(draftId) { const generation = this.generation; try { const data = await this.get('procurement-task-detail', { draft_id: draftId }); if (generation === this.generation && this.visible) { this.detail = data; this.selected = this.selected.filter(s => data.details.some(r => r.id === s.id && this.selectable(r))) } } catch (e) { this.error = e.message } },
    async post(path, data) { const res = await this.$axios.post(root + path, { shop: this.shop, ...data }); if (res.msg !== 'success') throw new Error(res.message || '操作失败'); await this.refresh() },
    async cancel(row) { try { await this.$confirm('取消后将释放该草稿占用的业务行。', '取消草稿'); await this.post('procurement-draft/cancel', { draft_id: row.draft_id }) } catch (e) { if (e.message) this.$message.error(e.message) } },
    async supplement() { try { await this.$confirm(`仅对选中的 ${this.selected.length} 项补采，已成功项不会重复采购。`, '确认补采'); await this.post('procurement-batch/supplement', { draft_id: this.detail.draft.draft_id, detail_ids: this.selected.map(r => r.id) }); this.selected = [] } catch (e) { if (e.message) this.$message.error(e.message) } }
  }
}
</script>

<style scoped>
.task-panel-meta { display: flex; flex-wrap: wrap; align-items: center; gap: 4px 18px; color: #909399; font-size: 12px; }
.task-panel-refresh { margin-left: auto; }
.task-panel-error { margin-top: 10px; }
.task-panel-table { margin-top: 12px; }
/* 操作列按钮统一居中排列，避免“只有详情”的行与“三个按钮”的行错位。 */
.task-panel-actions { display: flex; align-items: center; justify-content: center; flex-wrap: nowrap; gap: 6px; }
.task-panel-actions .el-button { margin-left: 0; }
.task-panel-pagination { display: flex; justify-content: flex-end; margin-top: 12px; }
.task-panel-detail { margin-top: 18px; padding-top: 14px; border-top: 1px solid #ebeef5; }
.task-panel-detail-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 10px; }
.task-panel-detail-header h3 { margin: 0; font-size: 14px; color: #303133; }
.task-panel-detail-meta { margin-top: 4px; color: #909399; font-size: 12px; line-height: 1.6; }
</style>
